export default "__VITE_ASSET__CJUxogfN__"